import { apiSlice } from './apiSlice'

/**
 * Sales Control › Credit Note PRINT preview query (Access Credit Note screen).
 * New slice — conflict-free with saleCreditNoteApi.ts (owned by another agent).
 *
 *   getCreditNotePrintPreview → GET /sale-credit-notes/print/preview?id={id}
 *
 * The print is keyed by ONE claim_credit_scs_id (the selected row). The backend
 * resolves the layout variant (Weight / Quality / Others) from the row
 * claim_type. Returns { title, html, message }. 422 detail = user-facing English
 * message (not found / claim type not accurate). keepUnusedDataFor: 0 (always
 * refetch).
 */
type PrintPreview = { title: string; html: string; message?: string }

const saleCreditNotePrintApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCreditNotePrintPreview: builder.query<PrintPreview, number>({
      query: (id) => ({
        url: '/sale-credit-notes/print/preview',
        params: { id },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
})

export const { useLazyGetCreditNotePrintPreviewQuery } = saleCreditNotePrintApi

export default saleCreditNotePrintApi
